import * as Yup from "yup";

const ValidationSchema = Yup.object().shape({
  youngestAge: Yup.number()
    .typeError("Age must be a number")
    .min(55, "Age must be at least 55")
    .max(100, "Age must be at most 100")
    .required("Age is required"),
  propertyValue: Yup.number()
    .typeError("Property value must be a number")
    .min(50000, "Property value must be at least $50,000")
    .max(100000000, "Property value must be at most $100,000,000")
    .required("Property value is required"),
  mortgageBalances: Yup.number()
    .typeError("Mortgage balances must be a number")
    .min(0, "Mortgage balances must be at least $0")
    .max(1000000, "Mortgage balances must be at most $1,000,000")
    .required("Mortgage balances is required"),
  state: Yup.string().required("State is required")
});

export default ValidationSchema;
